import { msalInstance } from "../../index";
import { getJWT } from "../../scripts/jwtToken";
import * as jose from "jose";

const corsUrl = "https://safyportalapi.azurewebsites.net/api/CORS?uri=";
const dsOrg =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "https://account.docusign.com"
    : "https://account-d.docusign.com";

// const ds_cid = "c1ca35da-5eb9-49db-9ed0-462c337ed342";
// const ds_impersonate = "688cbec3-04a4-40af-a1c0-5a36004dc1a8";
// const ds_org =
//   process.env.REACT_APP_ENVIRONMENT === "Production"
//     ? "account-d.docusign.com"
//     : "account-d.docusign.com";
// const ds_rurl = "http://localhost:3000";

const ds_pk =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? `-----BEGIN RSA PRIVATE KEY-----MIIEpAIBAAKCAQEAjtDCkfUrPEaFOaOCiapUROBQSLM8q8VR7RwM0U/8gNA8lMIdSmJQKutUwX2Bg81mToZAiB3myB5GiVv01zz1hHiUgbMhiDbyOCSi4H5a2p8M1sDsZ9rHqwJ6Zmj/MZeeKhkPb2behbq5MrMyGKcFZQq9yYVMcnXqXYHqk7weL7YDbX9rw4wVxVN4NjHVKqiQ827M7WKiSm/LuAjWmR5PfO0RZVr90BwkJTfFGDqkMSW2lhhaepi8S3TleH/GsNyTvHD3aa1aA+Es64v8Xa4DRDSQqJWDVsXck96pcfcyx8+VjsO4POsOnpiAfwqQD3svsMXiNHgJs9I2TAuuVVrlbwIDAQABAoIBAAwH+Cw1nDPSuQx3Ats4FytKPlkxiE3sLI+uCkJj26C6ajAZ/j+y8o/7DUPTn+KLni/FTZBp/HQlYMnXjlPHleNYCSK4BX4lKtih9Xq2Ck9akMlSrVe+bY2xgsA33i++VxuyysMWxm47obhssi6ze1fcxMpCSYNm/ZxtAmb5tQ1NxsAmTkHocU/DvpaxLpaGbng9rrfSX9XIImQpem6RbIaEWa6e8gxo4AzW1CZAynQx3lijdbQ25YeajYcCLdBEr1rNyfxTAe3qXDXWcWV5EOH2Am3qE6VOu1ItdFWQWbwWfgiLUz2qqyBYGBGYLDghggKQkDkClMVp5u0TojqMVoECgYEAzzQ2O7rCULp1GODzAEKkhwJS07aNB4Ruy6dGdteqFFi9jrtFhKi0fOXDAw6wyAIjM/pnuDNfHh4NngGKwt1vVV/BlkD4KUiN1jDsJn0lcWczEf5vvRNKQznkxYaUvcEIXCFcLITr92sqT9U5wG6hAL3PuYJ8QtoiQpvbOQixDC8CgYEAsHK71nytPjGJjFYjFyJMyoZok3Vhj3PLTDBLvHGpIg8MH0B5Ud0Ik6W0PKGtETrRnOAjhNlxdRJd6Brt7ce4AchAzPXXiZ+hUxpkJgFvARmRZ3vlEIcpxqhZYrCapE1LRqQChNtJeaP00ycXiBFazYaSbizGsfA8zarI22TvKsECgYEAn/jpnjfUaktquKiENEE/kVTD6dzZCWK/v9AH4R0knMzenOINDBzMLFmftC6VYfX0g97iUR6oYzJExSbfoQ8hM8LYTU8fyY/QofvndtfMHr/UeCH+1vWbskdyTuZW1CHCeI7xARYmsEE2y6gODHndKBtj0w/hLCQJq291U5VYS9UCgYAv2S0u4Ohp8S0HrWQepeKFGSXKtw4ZxKDgrEgddgUTg1kaMHW1yWbGAy15M66m+XhWPkHjiMPHp49nncXfsUUo1pEcA57LZ0psKr/1vnXHqpNPqL1ZWg3uHUEADjwhSgSbx2YXeQ/XuKpviC5Na8df7JpQ3juTjT4v15xYQmrJAQKBgQDJ6IU3wL8OMb4Nxg+igemd3xjA80tMFJlz6GXEfH+WJZeLzaQIszLA0klYpfGg/aI0YvNvfPR9Tkrsgx4DZ9WMpLBCEk29HlILITc7MPuAlhPbbL65NLfnHwjSOTdWLPICeKsCQ/3xIKqrQ9sgxoMgfKyqv5XUD/WkwIG6kxnnrw==-----END RSA PRIVATE KEY-----`
    : `-----BEGIN RSA PRIVATE KEY-----MIIEpAIBAAKCAQEA2rqyt4+ovYDQl3I/8c3R1b+mBkd5dUi0P5QFBTS9hIQskZ1LgtM+zd9/cQHYnebAf56drR/j5ERufFIKuAD3C3FDN8oPaJzFptQEnu82VKXEqzH1LD64Va/JfdCsmYcKgoeugU/l6VZ1rDOYHeerj/X6U4YELc8k0IeoyJwlvaV2g/Ay9Vomp/RsovwMMSw0xq7qoSxxkTgH/VzCGTjygRfScCw5ac9qa31U1tea+8vqmgdXTcNQOMd8crzv3Cx2ucLozEK9TLEDjexgUx7fXvFr/bOyk/7Pk0JwhwAG/dDcCsyFwfDxFgp/dSGu/cjZWnPyYV/+5EZlNTC8hK5TbQIDAQABAoIBABsvEuEPYKhUpxf7YgkaTFblX6vuHCFAbO5t5gXUnS0oBCYAx4611FtfyIXx9csCD7CMtQn8KaWH/7dBtwVRUWLBq9n2Kd4VhdcLCJv8HON+SqgAKHlcPiqgE0mosprOFrdMR5rYpDlQvoUtUF1/Gmpk5ryUrlZHJUspYQe1qFceS16YK6a8pu2b2NI+fmBFEk9Tu9qn6JTaJfruI8F+4FjfOdnsF9jrEv5nt8GvXzxLThwk19BofKYkGAw+fXz6kSqSjp13mCHEWcKZSrd3ysjLJMrsSJOQOEhv6OeCb6QXJetBYYLZeK/RFBDRjjnvjw5QchgVHpY9/rQ/brqE250CgYEA/OXYE0JTAV1nxhkTUZU9ZCAv6tojD0MMWoBLawG+s81njyHI0kWLp9BVQ1Mb2pyptWJyIJjItKW+aGmTzE9Z5b11+4zaY5JK8L2io9sL+uGkUtxweNcKd9/lWPZ5qNGanyNj3q5NdNmh4QQGahqCNA/ESNIswu/wvi/ROZRs3n8CgYEA3WmOo83MCScibxe+h6sBX0THIEOiSPrjhNi/CLdH5gNw0FRUkzTkz9rH0tx9FPYLiK6UXcxik9KgiPo24eCdMW7XXxZqeAwKH4tkILU4oebQpacfONzk4jmQqJImB3ioNDdrxYaEWjgkOu/IWr9zv5pYpn549QE78bEapfweMBMCgYEAg86TUG5X7rUs+e1lyTZ8Oawg7UllznWGgcCuDgZpyzJ6D/puvVDr2bnWRnGRad4PAW9exih7KtPbqnWkR27wDrIxRLsDs7OyhUiA9N+cndRunZUwtXp2hUXXNge4HsmnydtbGNtFmWo4WZuMcE6Cn/m7tqx8EdmWYrlvVZBLMacCgYEAlEeHAWhnhpGw29l4/f6mEplLCe6BloJ/MI6/kSS9f+s5+Csh4NwBiLoqLKsBEbKdktHoBtFEC195p4J6ktcMLvjeP44Ri4f0l5+QVN9IqBSeEvJTVI+KsX5/xITr9wD1FNMw1734kTsb+GRxN2UULXM+f3Ifq2VCMeC7ygGIbgUCgYAu93MmmimzszsiiQwg9CUcFn85DUdZvzpGNWY5wfAGW/BxhKF3U/SWThncsjj1tf3iGoJB+jsumZ5zuvCOTR1VfoasKB2tsvFCqc706Kd14vkpfuOzK20JzjDrDJuSDKkbRT6V/wJZIwqR5+Pu4C25sup70BlpgbM9Uc4pMi6Hjg==-----END RSA PRIVATE KEY-----`;
const ds_tokenurl =
  "https://account-d.docusign.com/oauth/auth?response_type=code&scope=signature impersonation&client_id=c1ca35da-5eb9-49db-9ed0-462c337ed342&redirect_uri=http://localhost:3000";

const dsAccountId =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "55e22bc7-be51-4dd9-8afe-c039d8dfe2fb"
    : "f396fae1-4bdf-4d6c-b349-ef73aaf408ec";
const dsBaseURI =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "https://na3.docusign.net"
    : "https://demo.docusign.net";

export async function docusignAccess() {
  var access_token = {};

  const jwtToken = await getJWT();
  //const jwtToken = `eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJjMWNhMzVkYS01ZWI5LTQ5ZGItOWVkMC00NjJjMzM3ZWQzNDIiLCJzdWIiOiI2ODhjYmVjMy0wNGE0LTQwYWYtYTFjMC01YTM2MDA0ZGMxYTgiLCJhdWQiOiJhY2NvdW50LWQuZG9jdXNpZ24uY29tIiwiaWF0IjoxNjgzODA5NTUxLCJleHAiOjE2ODM4MTMxODEsInNjb3BlIjoic2lnbmF0dXJlIGltcGVyc29uYXRpb24ifQ.1A6Fw7F9XxJnuWXp_XsXSk_VotfnPSX8btKbE3818Py5CayKhg_IKiqPt-tzkqSOnRpyd1wxd9SuSbGeF9WAWCXVA4P7ihA4r1c9kOXlBoLWuRpXrwGNgqIcX46cuykB3uMpA367r3BDnTb12Aqf_8j2oPzJS-OYFoZ_rQuiZlMan40-FfCcIvGXhFn0pzFiG9ModD-HmSH_gfwLwe8DuYuR5e65kX5BWU7qaD7ZI-CEKwTwMn-tgLYGz9nxN9dfdmcss1BmfXLlMAGKJr8Oz6fNByfvelwfucB73OFSKsGUi4PjO07WBD7j4TuZnbBBAJ6_iPQSC_B0AZRULAsBcw`;

  // var jwtToken = jws.sign(
  //   {
  //     iss: "c1ca35da-5eb9-49db-9ed0-462c337ed342",
  //     sub:
  //       process.env.REACT_APP_ENVIRONMENT === "Production"
  //         ? "64f26839-dd8f-483b-9932-0f3fc5d619bd"
  //         : "688cbec3-04a4-40af-a1c0-5a36004dc1a8",
  //     aud:
  //       process.env.REACT_APP_ENVIRONMENT === "Production"
  //         ? "account.docusign.com"
  //         : "account-d.docusign.com",
  //     iat: Math.floor(Date.now() / 1000) - 30,
  //     exp: Math.floor(Date.now() / 1000) + 60 * 60,
  //     scope: "signature impersonation",
  //   },
  //   ds_pk,
  //   {
  //     algorithm: "RS256",
  //   }
  // );
  console.log("Docusign jwt token: ", jwtToken);

  //Get Docusign accessToken with JWT
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
    assertion: jwtToken,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  access_token.token = await fetch(
    `${corsUrl}${dsOrg}/oauth/token`,
    requestOptions
  )
    .then((response) => response.json())
    .then(async (result) => {
      console.log("Docusign Token Raw", result);
      var ds_token = JSON.parse(result);
      access_token.token = ds_token;
      access_token.exp = Math.floor(Date.now() / 1000) + 60 * 60;
      //console.log("Docusign Token", ds_token);
      return ds_token;
    })
    .catch((error) => console.log("error", error));

  access_token.account_id = dsAccountId;
  access_token.base_uri = dsBaseURI;
  // var accountHeaders = new Headers();
  // accountHeaders.append(
  //   "Authorization",
  //   `Bearer ${access_token.token.access_token}`
  // );

  // var accountOptions = {
  //   method: "GET",
  //   headers: accountHeaders,
  //   redirect: "follow",
  // };

  // await fetch(`${corsUrl}${dsOrg}/oauth/userinfo`, accountOptions)
  //   .then((response) => response.json())
  //   .then(async (result) => {
  //     const acc = JSON.parse(result);
  //     console.log("Docusign Account", acc);
  //     access_token.account_id = acc.accounts[0].account_id;
  //     access_token.base_uri = acc.accounts[0].base_uri;
  //   })
  //   .catch((error) => console.log("error", error));

  console.log("Docusign at account", access_token);
  return access_token;
}

//
const isTokenExpired = () => {
  const activeAccount = msalInstance.getActiveAccount();
  const token = activeAccount?.idTokenClaims;
  const exp = token.exp;
  console.log("Is Token Expired date", exp);

  let expired = true;
  try {
    console.log(
      "Exp: ",
      exp * 1000,
      "Now",
      Date.now(),
      Date.now() >= exp * 1000
    );
    if (exp * 1000 >= Date.now()) {
      console.log("False");
      expired = false;
    }
  } catch (err) {
    console.log("error");
  }
  console.log("Expired ?", expired);
  return expired;
};

export async function sendTemplate(access, template) {
  console.log("Sending Docusign Template", template);
  template.compositeTemplates[0].serverTemplates[0].templateId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? template.compositeTemplates[0].liveTemplate
      : template.compositeTemplates[0].testTemplate;
  //check Access Token expiration
  let token = access;
  console.log("Checking Docusign for expired token", token.exp);
  const expired = isTokenExpired(token.exp);
  if (expired === true) {
    console.log("Docusign Token Expired, Getting new token");
    token = await docusignAccess();
    console.log("New Docusign Token received");
  }
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  template.notification = {
    useAccountDefaults: true,
  };
  var raw = JSON.stringify(template);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${token.base_uri}/restapi/v2.1/accounts/${token.account_id}/envelopes`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;
}

export async function sendRecipientViewRequest(
  access,
  envelope,
  recipientView
) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${access.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(recipientView);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${access.base_uri}/restapi/v2.1/accounts/${access.account_id}/envelopes/${envelope.envelopeId}/views/recipient`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;
}

export async function sendInPersonSigningRequest(
  access,
  envelopeId,
  inPersonJSON
) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${access.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(inPersonJSON);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${access.base_uri}/restapi/v2.1/accounts/${access.account_id}/envelopes/${envelopeId}/recipients`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;
}

export async function sendVoidRequest(envelopeId, reason) {
  const access = await docusignAccess();
  console.log("void access token", access);
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${access.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify({
      status: "voided",
      voidedReason: reason,
    }),
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${access.base_uri}/restapi/v2.1/accounts/${access.account_id}/envelopes/${envelopeId}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;
}

export async function resendEnvelope(envelope) {
  let env = envelope;
  console.log(envelope, env);
  if (env.recipients.signers[0].clientUserId) {
    delete env.recipients.signers[0].clientUserId;
    delete env.purgeState;
  }

  const access = await docusignAccess();
  console.log("void access token", access);
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${access.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify({}),
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${access.base_uri}/restapi/v2.1/accounts/${access.account_id}/envelopes/${env.envelopeId}?resend_envelope=true`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;
}

export async function getAuditHistory(envelope) {
  const access = await docusignAccess();
  console.log("audit access token", access);
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${access.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${access.base_uri}/restapi/v2.1/accounts/${access.account_id}/envelopes/${envelope}/audit_events`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      console.log("Audit", JSON.parse(result));
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;

  // var accountOptions = {
  //   method: "GET",
  //   headers: accountHeaders,
  //   redirect: "follow",
  // };

  // await fetch(`${corsUrl}${dsOrg}/oauth/userinfo`, accountOptions)
  //   .then((response) => response.json())
  //   .then(async (result) => {
  //     const acc = JSON.parse(result);
  //     console.log("Docusign Account", acc);
  //     access_token.account_id = acc.accounts[0].account_id;
  //     access_token.base_uri = acc.accounts[0].base_uri;
  //   })
  //   .catch((error) => console.log("error", error));
}

export async function sendForExternalSignatures(
  pdfBytes,
  regardingID,
  regardingName,
  docName,
  emailSubject,
  emailBlurb,
  signersJSON
) {
  const token = await docusignAccess();
  console.log("New Docusign Token received");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token.token.access_token}`);
  myHeaders.append("Content-Type", "application/json");

  const compositeTemplate = {
    emailSubject: emailSubject,
    emailBlurb: emailBlurb,
    status: "sent",
    notification: {
      useAccountDefaults: true,
    },
    compositeTemplates: [
      {
        document: {
          documentId: "1",
          name: docName,
          fileExtension: "pdf",
          documentBase64: pdfBytes,
        },
        // serverTemplates: [
        //   {
        //     sequence: "1",
        //     templateId: "5704ecb6-e419-409d-b0c5-181de8df8d74",
        //   },
        // ],
        inlineTemplates: [
          {
            sequence: "1",
            recipients: {
              signers: signersJSON,
            },
            carbonCopies: [
              {
                email: JSON.parse(localStorage.getItem("safyInfo")).user.email,
                name: JSON.parse(localStorage.getItem("safyInfo")).user
                  .displayName,
                recipientId: "1",
                routingOrder: 1,
              },
            ],
          },
        ],
      },
      {
        serverTemplates: [
          {
            sequence: "1",
            templateId:
              process.env.REACT_APP_ENVIRONMENT === "Production"
                ? "320d63cd-338a-499f-a65b-ad77c0cab6b2"
                : "5704ecb6-e419-409d-b0c5-181de8df8d74",
          },
        ],
        inlineTemplates: [
          {
            sequence: "2",
            recipients: {
              signers: signersJSON,
              carbonCopies: [
                {
                  email: JSON.parse(localStorage.getItem("safyInfo")).user
                    .email,
                  name: JSON.parse(localStorage.getItem("safyInfo")).user
                    .displayName,
                  recipientId: "1",
                  routingOrder: 1,
                },
              ],
            },
            customFields: {
              textCustomFields: [
                {
                  fieldId: "0",
                  name: "RegardingID",
                  requried: false,
                  show: false,
                  value: regardingID,
                },
                {
                  fieldId: "1",
                  name: "RegardingName",
                  required: false,
                  show: false,
                  value: regardingName,
                },
                {
                  fieldId: "2",
                  name: "RegardingOrg",
                  required: false,
                  show: false,
                  value:
                    process.env.REACT_APP_ENVIRONMENT === "Production"
                      ? "SOARLive"
                      : "SOARD365Base",
                },
              ],
            },
          },
        ],
      },
    ],
  };

  var raw = JSON.stringify(compositeTemplate);

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const data = await fetch(
    `${corsUrl}${token.base_uri}/restapi/v2.1/accounts/${token.account_id}/envelopes`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return JSON.parse(result);
    })
    .catch((error) => console.log("error", error));

  return data;
}
